/* eslint-disable import/no-cycle */
/* eslint-disable class-methods-use-this */
import { BaseModel } from '@/_models/base'

export class OrganizationMember extends BaseModel {
  constructor(id = null) {
    super()

    this.id = id
    this.firstName = null
    this.lastName = null
    this.email = null
    this.effectiveRole = null
  }

  static modelName = 'organizationMember'

  static modelNamePlural = 'organizationMembers'

  fromJSON(json) {
    const item = Object.assign(new OrganizationMember(), json)
    item.effectiveRole = json.effectiveRole ?? null
    return item
  }
}

export const cOrganizationMember = new OrganizationMember()
